import { createBrowserRouter } from "react-router";
import { BaseLayout } from "./Layout";
import { IndexPage } from "./pages/Index";
import { CallbackPage } from "./pages/Callback";
import { SessionPage } from "./pages/SessionPage/Index";
import { ActionsPage } from "./pages/ActionsPage/Index";
import { ResourcePage } from "./pages/ResourcePage/Index";
import { ScriptResultViewPage } from "./pages/ScriptResultView/Index";
import { ScreenWatch } from "./pages/SessionPage/ScreenWatch";
import { ControlPage } from "./pages/ControlPage/Index";

export const router = createBrowserRouter([
  {
    path: '/',
    Component: BaseLayout,
    children: [
      {
        path: '',
        Component: IndexPage,
      },
      {
        path: 'sessions',
        Component: SessionPage,
      },
      {
        path: 'actions',
        Component: ActionsPage,
      },
      {
        path: 'control',
        Component: ControlPage,
      },
      {
        path: 'resources',
        Component: ResourcePage,
      },
      {
        path: 'script-result',
        Component: ScriptResultViewPage,
      }
    ],
  },
  {
    path: '/sessions/screen',
    Component: ScreenWatch,
  },
  {
    path: 'callback',
    Component: CallbackPage,
  },
]);
